<template>
  <el-dialog v-model="dialogVisible" :title="title" width="480px" :append-to-body="true">
    <div class="qr-code-container">
      <template v-if="qrCodeUrl">
        <vue-qrcode :value="qrCodeUrl" :options="{ width: 200, margin: 0 }" ref="qrcodeRef" />
        <div class="mt-1em">绑定店铺账号的微信扫码购买</div>
      </template>
      <el-empty v-else class="h-200px w-200px" :image-size="100">
        <template #description>
          <div>二维码生成失败，您可到采购商城搜索"<span class="fw-bold">{{ searchKeyword }}</span>"购买</div>
        </template>
      </el-empty>
    </div>
  </el-dialog>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core'

interface Props {
  show?: boolean
  title?: string
  qrCodeUrl?: string
  searchKeyword?: string
}

interface Emits {
  (e: 'update:show', value: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  show: false,
  title: '扫码购买',
  qrCodeUrl: '',
  searchKeyword: '',
})

const emit = defineEmits<Emits>()

// 使用 useVModel 替换原来的 computed
const dialogVisible = useVModel(props, 'show', emit)
</script>

<style scoped lang="scss">
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
